// extracted by mini-css-extract-plugin
export default {"link":"CTAButton_link__qY9wT"};